import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import CreateGoal from "./routes/CreateGoal";
const mergeReducers = (prevState, nextState) => {
  return {
    ...prevState,
    ...nextState,
    isNotificationProcessed: false,
  };
};
export default store => ({
  path: "goals",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import("./components"),
        import("./modules/StudentGoalsModules"),
        import("Post/modules/PostModule"),
      ]).then(([importedModule0, importedModule1, importedModule2]) => {
        const component = importedModule0.default;
        const goalReducer = importedModule1;
        const post = importedModule2.default;
        const key = goalReducer.NAME;
        const prevReducer = store.asyncReducers[key];
        const nextReducer = goalReducer.default;
        const reducer = prevReducer
          ? (state, action) =>
              mergeReducers(
                prevReducer(state, action),
                nextReducer(state, action)
              )
          : nextReducer;
        injectReducer(store, {
          key,
          reducer,
        });
        injectReducer(store, {
          key: "post",
          reducer: post,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [CreateGoal(store)],
});
